import React, { useEffect, useState } from "react";
import { Center, Card, CardBody, Heading, VStack, Alert, AlertIcon, Spinner, Text, Image } from "@chakra-ui/react";
import { useAuth } from "hooks/useAuth";
import { useNavigate, useLocation } from "react-router-dom";
import { AUTH } from "config/config";
import googleLoginButton from "assets/img/google_login_button.png";

const Login = () => {
  const navi = useNavigate();
  const location = useLocation();
  const { isAuthenticated, loading } = useAuth();
  const [loginLoading, setLoginLoading] = useState(false);

  useEffect(() => {
    if (isAuthenticated && !loading) {
      navi("/");
    }
  }, [isAuthenticated, loading, navi]);

  const handleGoogleLogin = () => {
    setLoginLoading(true);
    window.location.href = AUTH.GOOGLE;
  };

  const getErrorMessage = () => {
    const urlParams = new URLSearchParams(location.search);
    const error = urlParams.get('error');

    switch (error) {
      case 'no_code':
        return '인증 코드를 받지 못했습니다.';
      case 'token_failed':
        return '토큰 교환에 실패했습니다.';
      case 'userinfo_failed':
        return '사용자 정보 조회에 실패했습니다.';
      case 'no_permission':
        return '접근 권한이 없습니다. 관리자에게 문의하세요.';
      case 'session_failed':
        return '세션 생성에 실패했습니다.';
      case 'db_error':
        return '데이터베이스 연결에 실패했습니다. 잠시 후 다시 시도해주세요.';
      case 'sync_failed':
        return '사용자 정보 동기화에 실패했습니다.';
      case 'wait_group':
        return '계정이 승인 대기 중입니다. 관리자에게 문의하세요.';
      default:
        return null;
    }
  };

  const errorMessage = getErrorMessage();

  if (loading) {
    return (
      <Center position={"fixed"} top={0} left={0} width={"100vw"} height={"100vh"}>
        <VStack spacing={4}>
          <Spinner size="xl" />
          <Text>세션 확인 중...</Text>
        </VStack>
      </Center>
    );
  }

  return (
    <Center position={"fixed"} top={0} left={0} width={"100vw"} height={"100vh"}>
      <Card width={"600px"} height={"400px"}>
        <CardBody>
          <Center width={"100%"} height={"100%"}>
            <VStack spacing={4}>
              <Heading>Hybe Watermark System</Heading>

              {errorMessage && (
                <Alert status="error" borderRadius="md">
                  <AlertIcon />
                  {errorMessage}
                </Alert>
              )}

              <Image
                src={googleLoginButton}
                alt="Google로 로그인"
                onClick={handleGoogleLogin}
                cursor={loginLoading ? "not-allowed" : "pointer"}
                opacity={loginLoading ? 0.6 : 1}
                _hover={{ transform: "scale(1.02)" }}
                maxWidth="200px"
                width="auto"
                height="auto"
              />
              {loginLoading && (
                <Text fontSize="sm" color="gray.500">
                  로그인 중...
                </Text>
              )}
            </VStack>
          </Center>
        </CardBody>
      </Card>
    </Center>
  );
};

export default Login;
